<template>
  <div>
    <b-label>Користувач</b-label>
    <employee-autocomplete
      v-model="delegationCredentials.delegateUserId"
      :error-messages="getErrorMessages(v$.delegateUserId)"
      @blur="v$.delegateUserId.$touch()"></employee-autocomplete>

    <b-select
      v-model="delegationCredentials.assignmentTypeId"
      :error-messages="getErrorMessages(v$.assignmentTypeId)"
      :items="
        $directory
          .get('delegationAssignmentTypes')
          .filter(item => item.id !== 1)
      "
      :loading="$loading.isLoading('delegationAssignmentTypes')"
      label="Тип призначення"
      @blur="v$.assignmentTypeId.$touch()"
      @focus="$directory.fill('delegationAssignmentTypes')"></b-select>

    <b-textarea
      v-model="delegationCredentials.description"
      label="Опис"
      placeholder="Причина або деталі делегування"
      rows="2"></b-textarea>

    <v-row>
      <v-col cols="12" md="6">
        <b-input-date
          v-model="delegationCredentials.startDate"
          :disabled-dates="disabledDates"
          :error-messages="getErrorMessages(v$.startDate)"
          label="Дата початку"
          @blur="v$.startDate.$touch()"></b-input-date>
      </v-col>
      <v-col cols="12" md="6">
        <b-input-date
          v-model="delegationCredentials.endDate"
          :disabled-dates="disabledDates"
          :error-messages="getErrorMessages(v$.endDate)"
          label="Дата закінчення"
          @blur="v$.endDate.$touch()"></b-input-date>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { BInputDate, BLabel, BTextarea } from 'best-modules/components'
import EmployeeAutocomplete from '@/components/inputs/employee-autocomplete/EmployeeAutocomplete.vue'
import { computed, PropType, reactive } from 'vue'
import { fillDirectory } from '@/directory'
import { required, useVuelidate } from '@/plugins'
import { getErrorMessages } from 'best-modules/utils'
import { userDelegationCreate } from '@/requests/user'
import { getDatesInRange } from '@/utils/helpers'
import { Dialog } from '@/dialog'

export default {
  name: 'DelegationCreate',
  components: { EmployeeAutocomplete, BTextarea, BInputDate, BLabel },
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { getErrorMessages },
  setup(props) {
    fillDirectory(['delegationAssignmentTypes'])

    const delegationCredentials = reactive({
      delegateUserId: null,
      assignmentTypeId: null,
      description: '',
      startDate: null as any,
      endDate: null as any,
    })

    const rules = computed(() => {
      return {
        delegateUserId: { required },
        assignmentTypeId: { required },
        startDate: { required },
        endDate: { required },
      }
    })

    const v$ = useVuelidate(rules, delegationCredentials)

    const disabledDates = computed(() => {
      const delegatedUser = props.dialog.dialogData.delegations.find(
        (delegation: any) =>
          delegation.delegateUserId === delegationCredentials.delegateUserId
      )

      if (delegatedUser) {
        return getDatesInRange(delegatedUser.startDate, delegatedUser.endDate)
      } else {
        return []
      }
    })

    const submit = () => {
      return userDelegationCreate(delegationCredentials).then(res => {
        return res
      })
    }

    return {
      delegationCredentials,
      disabledDates,
      submit,
      v$,
    }
  },
}
</script>
